import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, CanActivateChild, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';


@Injectable()
export class PermissionGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService) {}
  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkUserPermissions(next);
  }
  canActivateChild(next: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkUserPermissions(next);
  }
  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkUserPermissions(route);
  }
  /**
   * Checking user permission on route.
   * @param {ActivatedRouteSnapshot} next
   * @returns {boolean}
   */
  checkUserPermissions (next: ActivatedRouteSnapshot | Route): boolean {
    if (next.data.permission === 'role_edit' || next.data.permission === 'role_add') {
      return this.authService.userProfile.roleId < 2;
    }
    return next.data.permission ? this.authService.hasPermission(next.data.permission) : true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/permission.guard.ts